import ShopDTO from "@/dto/shop/ShopDTO";
import ShopSettingDTO from "@/dto/shop/ShopSettingDTO";
import ShopType from "@/enum/ShopType";
import moment from "moment";
import GlobalStore from "@/store";
import { getSETokenFromQn } from "@qn/services/api/getToken";
import AuthTokenHolder from "@/services/http/AuthTokenHolder";
import OrderDTO from "@/dto/order/OrderDTO";
import { CallbackUrl } from "@/services/callback";
import SupplierPartnershipsStore from "@/store/SupplierPartnershipsStore";
import SellerType from "@/enum/SellerType";

/** AppKey登录方式的ShopTypes */
export const appKeyLoginShopTypes = [
    ShopType.WEBUY,
    ShopType.HAIZIWANG,
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.DOUBB,
];

/** 发货易自支付渠道ShopTypes */
export const EcMarketShopTypes = [
    ShopType.WEIDIAN,
    ShopType.MOGUJIE,
    ShopType.DOUBB,
    ShopType.XIAOHONGSHU,
    ShopType.DUXIAODIAN,
    ShopType.ALI_C2M,
    ShopType.FKW,
    ShopType.FKMDT,
    ShopType.HKMDXT,
    ShopType.WSC,
    ShopType.INDEPENDENT_MANUAL,
    ShopType.KTT,
    ...appKeyLoginShopTypes,
];

/** 平台续费ShopTypes */
export const PlatformMarketShopTypes = [
    ShopType.TAOBAO,
    ShopType.TAOBAO_DISTRIBUTION,
    ShopType.PINDUODUO,
    ShopType.PDD_FDS,
    ShopType.ALIBABA,
    ShopType.JD,
    ShopType.JD_PURCHASE,
    ShopType.WEIMOB,
    ShopType.WEIMOB_EC,
    ShopType.YOUZAN,
    ShopType.DOUDIAN,
    ShopType.DOUDIAN_IOP,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.KWAI,
    ShopType.SUNING,
];

/**
 * 目前支持发货易分销业务的平台
 *
 * 【注意】
 * 每新增一个平台时，要检查是否需要更新【getCorrespondSupplierShopType】方法
 */
export const SupportDropShippingShopTypes = [
    ShopType.TAOBAO,
    ShopType.PINDUODUO,
    ShopType.DOUDIAN,
    ShopType.WEIDIAN,
    ShopType.MOGUJIE,
    ShopType.WEIMOB_EC,
    ShopType.XIAOHONGSHU,
    ShopType.DUXIAODIAN,
    ShopType.MANUAL,
    ShopType.ALI_C2M,
    ShopType.JD,
    ShopType.YOUZAN,
    ShopType.KWAI,
    ShopType.ALIBABA,
    ShopType.WEBUY,
    ShopType.HAIZIWANG,
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.FKW,
    ShopType.FKMDT,
    ShopType.HKMDXT,
    ShopType.WSC,
    ShopType.SUNING,
    ShopType.CHANNEL_SHOP,
    ShopType.INDEPENDENT_MANUAL,
    ShopType.TAOBAO_DISTRIBUTION,
    ShopType.KTT,
    ShopType.DOUBB,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.JD_PURCHASE,
];

/** 分销店铺类型 */
export const SupplierShopTypes = [
    ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
    ShopType.PDD_DROP_SHIPPING_SUPPLIER,
    ShopType.JD_DROP_SHIPPING_SUPPLIER,
    ShopType.OTHER_DROP_SHIPPING_SUPPLIER,
    ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
];

export const apiShopTypes = [ShopType.FKW, ShopType.FKMDT, ShopType.HKMDXT, ShopType.SDMM, ShopType.WSC];

/**
 * 优先显示用户昵称的店铺类型列表
 */
export const showUserNicknameShopTypes = [
    ...SupplierShopTypes,
    ShopType.KWAI,
    ShopType.KWAI_DROPSHIP,
    ShopType.DOUDIAN,
];

/**
 * 不展示重新授权按钮的店铺
 */
export const hasNoReAuthButtonShopTypes = [
    ShopType.MANUAL,
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
    ShopType.ALIBABA_SUPPLIER,
    ShopType.YOUZAN,
    ShopType.SUNING,
    ShopType.FKW,
    ShopType.FKMDT,
    ShopType.HKMDXT,
    ShopType.WSC,
    ShopType.SDMM,
    ShopType.CHANNEL_SHOP,
    ShopType.CHANNEL_SHOP_DROPSHIP,
    ShopType.CHANNEL_SHOP_SUPPLIER,
    ShopType.WEBUY,
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.HAIZIWANG,
    ShopType.YMDY,
    ShopType.HCTY,
    ShopType.INDEPENDENT_MANUAL,
    ...SupplierShopTypes,
];

/**
 * 平台不需要升级店铺类型
 */
export const doNotNeedUpgradePremiumShopTypes = [
    /** 版本与所属店铺一致,无需单独升级*/
    ShopType.MANUAL,
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
    ShopType.ALIBABA_SUPPLIER,
    /** 以下平台只有高级版 */
    ShopType.YOUZAN,
    ShopType.WEIMOB,
    ShopType.WEIMOB_EC,
    ShopType.SUNING,
    ShopType.HAIZIWANG,
    ...SupplierShopTypes,
];

export const supportSubscribeShopTypes = [
    ShopType.TAOBAO,
    ShopType.TAOBAO_DISTRIBUTION,
    ShopType.PINDUODUO,
    ShopType.ALIBABA,
    ShopType.JD,
    ShopType.JD_PURCHASE,
    ShopType.WEIDIAN,
    ShopType.SUNING,
    ShopType.DOUDIAN,
    ShopType.DOUDIAN_IOP,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.KWAI,
    ShopType.KWAI_DROPSHIP,
    ShopType.MOGUJIE,
    ShopType.DOUBB,
    ShopType.XIAOHONGSHU,
    ShopType.DUXIAODIAN,
    ShopType.ALI_C2M,
    ShopType.WEBUY,
    ShopType.FKW,
    ShopType.FKMDT,
    ShopType.HKMDXT,
    ShopType.WSC,
    ShopType.CHANNEL_SHOP,
    ShopType.CHANNEL_SHOP_DROPSHIP,
    ShopType.CHANNEL_SHOP_SUPPLIER,
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.KTT,
    ShopType.HAIZIWANG,
    ShopType.YOUZAN,
];

/**
 * 支持”最后发货时间“的店铺类型列表
 */
export const ShippingDeadlineShopTypes = [
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.PINDUODUO,
    ShopType.PDD_FULFILLMENT,
    ShopType.DOUDIAN,
    ShopType.DOUDIAN_IOP,
    ShopType.DOUDIAN_SUPPLIER,
    ShopType.WEBUY,
    ShopType.KWAI,
    ShopType.KWAI_DROPSHIP,
    ShopType.WEBUY,
    ShopType.XIAOHONGSHU,
    ShopType.MANUAL,
    ShopType.INDEPENDENT_MANUAL,
    ShopType.JD,
    ShopType.JD_PURCHASE,
    ShopType.PDD_DROP_SHIPPING_SUPPLIER,
    ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
    ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
    ShopType.JD_DROP_SHIPPING_SUPPLIER,
    ShopType.OTHER_DROP_SHIPPING_SUPPLIER,
    ShopType.CHANNEL_SHOP,
    ShopType.CHANNEL_SHOP_DROPSHIP,
    ShopType.CHANNEL_SHOP_SUPPLIER,
    ShopType.TAOBAO,
    ShopType.ALIBABA,
    ShopType.ALIBABA_SUPPLIER,
];

export const TbPlatformShopTypes = [ShopType.ALIBABA, ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION];

export const DyPlatformShopTypes = [ShopType.DOUDIAN, ShopType.DOUDIAN_IOP, ShopType.DOUDIAN_SUPPLIER];

/**
 * 拼多多平台店铺
 */
export const PddPlatformShopTypes = [
    ShopType.PINDUODUO,
    ShopType.PDD_DROP_SHIPPING_SUPPLIER,
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
];

export const NotPlatformShopTypes = [...SupplierShopTypes, ShopType.MANUAL];

/**
 * 订单导出需要验证码的店铺类型列表
 */
export const orderExportShouldAddCaptchaShopList = [
    ShopType.TAOBAO,
    ShopType.XIAOHONGSHU,
    ShopType.TAOBAO_DISTRIBUTION,
    ...SupplierShopTypes,
];

export const YouZanAuthLink = "https://yingyong.youzan.com/center/my-apps";

export const TbGroupShopTypes = [ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION, ShopType.ALIBABA, ShopType.ALI_C2M];

/** -------------------------------------------------------------- */

export function isEcMarketShopExpired(shop: Pick<ShopSettingDTO, "type" | "subscriptionEndTime">) {
    return EcMarketShopTypes.includes(shop.type) && isShopExpired(shop?.subscriptionEndTime);
}

export function isShopExpired(subscriptionEndTime: string) {
    let isExpired = false;

    if (subscriptionEndTime) {
        isExpired = moment().isSameOrAfter(subscriptionEndTime);
    }

    return isExpired;
}

/**
 * 是否手工店铺 并且为已过期
 */
export function isManualShopExpired(shop: Pick<ShopSettingDTO, "type" | "subscriptionEndTime">) {
    if (shop?.type !== ShopType.MANUAL) {
        return false;
    }

    if (!shop?.subscriptionEndTime) {
        return true;
    } else {
        return moment().isSameOrAfter(shop.subscriptionEndTime);
    }
}

export function getDropShippingShops(shops: ShopDTO[]) {
    return shops.filter((shop) => {
        return [
            ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
            ShopType.PDD_DROP_SHIPPING_SUPPLIER,
            ShopType.JD_DROP_SHIPPING_SUPPLIER,
            ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
            ShopType.OTHER_DROP_SHIPPING_SUPPLIER,
        ].includes(shop.type);
    });
}

export function buildShopFetchGroup(shops: ShopDTO[]) {
    const group: Record<string, number[]> = {
        [ShopType.TAOBAO]: [],

        [ShopType.JD]: [],

        [ShopType.PINDUODUO]: [],

        [ShopType.DOUDIAN]: [],

        other: [],
    };

    for (const shop of shops) {
        switch (shop.type) {
            case ShopType.TAOBAO:
            case ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER:
            case ShopType.ALI_C2M:
            case ShopType.ALIBABA:
            case ShopType.ALIBABA_SUPPLIER:
            case ShopType.TAOBAO_DISTRIBUTION:
                group[ShopType.TAOBAO].push(shop.id);
                break;

            case ShopType.JD:
            case ShopType.JD_PURCHASE:
            case ShopType.JD_DROP_SHIPPING_SUPPLIER:
                group[ShopType.JD].push(shop.id);
                break;

            case ShopType.PINDUODUO:
            case ShopType.PDD_DROP_SHIPPING_SUPPLIER:
            case ShopType.PDD_FDS:
            case ShopType.PDD_FULFILLMENT:
            case ShopType.KTT:
                group[ShopType.PINDUODUO].push(shop.id);
                break;

            case ShopType.DOUDIAN:
            case ShopType.DOUDIAN_IOP:
            case ShopType.DOUDIAN_SUPPLIER:
            case ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER:
                group[ShopType.DOUDIAN].push(shop.id);
                break;
            default:
                group["other"].push(shop.id);
        }
    }

    Object.keys(group).forEach((key) => {
        if (!group[key].length) {
            delete group[key];
        }
    });

    return group;
}

export function shouldShowDropShippingDetail(shop: ShopDTO) {
    if (!shop) return false;

    return SupportDropShippingShopTypes.includes(shop.type);
}

/**
 * 判断当前店铺是否为需要显示订阅过期信息
 */
export function hasSupportSubscribeShop(shopType: ShopType) {
    return supportSubscribeShopTypes.includes(shopType);
}

/**
 * 隐藏店铺到期时间的店铺类型列表
 */
export const hideSubscriptionEndTimeShopTypes = [...SupplierShopTypes, ShopType.WEIMOB, ShopType.WEIMOB_EC];

export function getLogoutPlatformUrl(shopType: ShopType, redirectURL: string) {
    const search = new URLSearchParams();
    switch (shopType) {
        case ShopType.TAOBAO:
        case ShopType.TAOBAO_DISTRIBUTION:
            search.set("redirectURL", redirectURL);
            return `https://login.taobao.com/member/logout.jhtml?${search.toString()}`;

        case ShopType.ALIBABA:
        case ShopType.ALI_C2M:
            search.set("Done", redirectURL);
            return `https://login.1688.com/member/logout.htm?${search.toString()}`;

        // case ShopType.JD:
        //     return "https://passport.jd.com/uc/login?ltype=logout&ReturnUrl=";

        // case ShopType.WEIDIAN:
        //     return "https://sso.weidian.com/user/logout?redirect=";

        // case ShopType.ZHE800:
        //     return "https://passport.zhe800.com/sso/logout?return_to=";

        // case ShopType.SUNING:
        //     return "https://mpassport.suning.com/ids/logout?service=";
        default:
            return redirectURL;
    }
}

export async function buildShopReAuthRedirectUrlAndToken() {
    const isQN = import.meta.env.VITE_IS_QN;

    let redirectUrl = "/setting/shop";
    let token;

    if (isQN) {
        redirectUrl = CallbackUrl.REAUTH_SHOP;

        token = await getSETokenFromQn();
    } else {
        token = AuthTokenHolder.getToken();
    }

    return { token, redirectUrl };
}

/**
 * 能够解密的店铺类型列表
 */
const canDecryptedShopTypeList: ShopType[] = [
    ShopType.TAOBAO,
    ShopType.PINDUODUO,
    ShopType.JD,
    ShopType.JD_PURCHASE,
    ShopType.DOUDIAN,
    ShopType.KWAI,
    ShopType.ALI_C2M,
    ShopType.ALIBABA,
    ShopType.YOUZAN,
    ShopType.XIAOHONGSHU,
    ShopType.SUNING,
    ShopType.TAOBAO_DISTRIBUTION,
    ShopType.WEIDIAN,
    ShopType.MOGUJIE,
    ShopType.CHANNEL_SHOP,
    ShopType.CHANNEL_SHOP_DROPSHIP,
    ShopType.CHANNEL_SHOP_SUPPLIER,
    ShopType.WEIMOB_EC,
    ShopType.DUXIAODIAN,
    ShopType.AIKUCUN,
    ShopType.AIKUCUN_V2,
    ShopType.WEBUY,
    ShopType.KTT,
    ShopType.MANUAL,
    ShopType.INDEPENDENT_MANUAL,
    ShopType.FKW,
    ShopType.WSC,
    ShopType.FKMDT,
    ShopType.HKMDXT,
    ShopType.YMDY,
    ShopType.HCTY,
    ShopType.DOUBB,
];

/**
 * 能够批量解密的店铺类型列表
 */
const canBatchDecryptedShopTypeList = [ShopType.WEIDIAN, ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL];

/**
 * 能够解密的店铺类型
 */
export function getCurrentIsCanDecryptedShopType(shopType: ShopType) {
    return canDecryptedShopTypeList.includes(shopType);
}

/**
 * 能够批量解密的店铺类型
 */
export function getCurrentIsCanBatchDecryptedShopType(shopType: ShopType) {
    return canBatchDecryptedShopTypeList.includes(shopType);
}

export function hasBuyerNickname(shopType: ShopType) {
    return [
        ShopType.KWAI,
        ShopType.WEIMOB_EC,
        ShopType.KWAI_DROPSHIP,
        ShopType.PDD_FDS,
        ShopType.PDD_FULFILLMENT,
        ShopType.ALIBABA_SUPPLIER,
        ShopType.CHANNEL_SHOP,
        ShopType.CHANNEL_SHOP_DROPSHIP,
        ShopType.CHANNEL_SHOP_SUPPLIER,
        ShopType.DOUDIAN_IOP,
        ShopType.DOUDIAN,
        ShopType.DOUDIAN_SUPPLIER,
    ].includes(shopType);
}

// 淘宝  拼多多 抖店 京东 快手  阿里巴巴  微信小店  小红书  淘工厂  微店  爱库存  苏宁易购  国美  孩子王 鲸灵 好衣库  有赞  度小店  公主购 微盟微商城  蘑菇街 萌推
export function hasBlackList(shopType: ShopType) {
    return [
        ShopType.TAOBAO,
        ShopType.TAOBAO_DISTRIBUTION,
        // ShopType.PINDUODUO,
        ShopType.DOUDIAN,
        ShopType.JD,
        ShopType.KWAI,
        ShopType.ALIBABA,
        ShopType.CHANNEL_SHOP,
        ShopType.CHANNEL_SHOP_DROPSHIP,
        ShopType.CHANNEL_SHOP_SUPPLIER,
        ShopType.XIAOHONGSHU,
        ShopType.ALI_C2M,
        ShopType.WEIDIAN,
        ShopType.AIKUCUN,
        ShopType.AIKUCUN_V2,
        ShopType.SUNING,
        ShopType.HAIZIWANG,
        ShopType.WEBUY,
        ShopType.YOUZAN,
        ShopType.DUXIAODIAN,
        ShopType.WEIMOB_EC,
        ShopType.MOGUJIE,
        ShopType.FKW,
        ShopType.FKMDT,
        ShopType.HKMDXT,
        ShopType.WEIMOB_EC,
    ].includes(shopType);
}

/**
 * 千牛支持的店铺类型，不包含在其中的店铺跳转出去
 */
export const QNSupportShopTypes = [
    ShopType.TAOBAO,
    ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
    ShopType.ALI_C2M,
    ShopType.ALIBABA,
    ShopType.TAOBAO_DISTRIBUTION,
    ShopType.MANUAL,
    ShopType.INDEPENDENT_MANUAL,
];

export const MultiPlatformPrintModalShopTypes = [
    ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
    ShopType.OTHER_DROP_SHIPPING_SUPPLIER,
];

export function buildSingleShopOrderOriginCheckFunc(
    openModalShop: ShopDTO,
    supplierPartnershipsStore: SupplierPartnershipsStore,
) {
    if (!MultiPlatformPrintModalShopTypes.includes(openModalShop?.type)) return undefined;

    return (order: OrderDTO) => {
        let shopType: ShopType;

        if (order.supplierDropShippingInfo) {
            const partnership = supplierPartnershipsStore.retailerPartnershipMap.get(
                order.supplierDropShippingInfo.retailerShopId,
            );

            shopType = partnership?.shopType;
        }

        /**
         * 可能代理商被删除了，需要兜底归类
         * 淘系代发店铺如果找不到代理商店铺类型，归类来源于淘宝的订单
         * 淘系代发店铺如果找不到代理商店铺类型，归类来源于其他的订单
         */
        return shopType
            ? shopType
            : openModalShop.type === ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER
            ? ShopType.TAOBAO
            : ShopType.OTHER_DROP_SHIPPING_SUPPLIER;
    };
}

/** 不允许代发货退款中发货的店铺类型 */
export const DisabledPendingShipmentRefundingShipShopTypes = [
    ShopType.DOUDIAN,
    ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
];

export const preShipShopTypes = [ShopType.DOUDIAN, ShopType.TAOBAO, ShopType.PINDUODUO];

/** 支持售后管理的店铺类型 */
export const refundSupportedShopTypes = [
    ShopType.PINDUODUO,
    ShopType.KWAI,
    ShopType.DOUDIAN,
    ShopType.TAOBAO,
    ShopType.CHANNEL_SHOP,
];

/** 支持带货达人的店铺类型 */
export const affiliateMarketerShopTypes = [ShopType.DOUDIAN, ShopType.KWAI, ShopType.CHANNEL_SHOP];

export const notShowCreateOrderShopTypes = [ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL];
export const notShowCreateDecryptedOrderShopTypes = [
    ShopType.TAOBAO,
    ShopType.DOUDIAN,
    ShopType.DOUDIAN_IOP,
    ShopType.DOUDIAN_SUPPLIER,
];
export const showCreateEncryptedOrderShopTypes = [
    ShopType.TAOBAO,
    ShopType.DOUDIAN,
    ShopType.PINDUODUO,
    ShopType.KWAI,
    ShopType.JD,
    ShopType.XIAOHONGSHU,
];

export async function getUnexpiredAllowedShopIds(globalStore: typeof GlobalStore) {
    const allowedShopIds = globalStore.allowedShops.map(({ id }) => id);

    await globalStore.ensureShopSetting(allowedShopIds);

    return allowedShopIds.filter(
        (shopId) => !isShopExpired(globalStore.shopSettingMapping.get(shopId)?.subscriptionEndTime),
    );
}

export function isReissueSupported(shop: ShopDTO) {
    return [
        ShopType.TAOBAO,
        ShopType.TAOBAO_DISTRIBUTION,
        ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
        ShopType.PINDUODUO,
        ShopType.PDD_DROP_SHIPPING_SUPPLIER,
        ShopType.KWAI,
        ShopType.DOUDIAN,
    ].includes(shop?.type);
}

export function isReshipSupported(shop: ShopDTO) {
    return [
        ShopType.TAOBAO,
        ShopType.TAOBAO_DISTRIBUTION,
        ShopType.JD,
        ShopType.SUNING,
        ShopType.FANLI,
        ShopType.PINDUODUO,
        ShopType.DOUDIAN,
        ShopType.KWAI,
        ShopType.KWAI_DROPSHIP,
        ShopType.DOUDIAN_SUPPLIER,
        ShopType.PDD_FULFILLMENT,
        ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
        ShopType.JD_DROP_SHIPPING_SUPPLIER,
        ShopType.PDD_DROP_SHIPPING_SUPPLIER,
        ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
        ShopType.FKW,
        ShopType.FKMDT,
        ShopType.HKMDXT,
        ShopType.YMDY,
        ShopType.WSC,
        ShopType.SDMM,
        ShopType.OTHER_DROP_SHIPPING_SUPPLIER,
        ShopType.DOUDIAN_IOP,
        ShopType.CHANNEL_SHOP,
        ShopType.CHANNEL_SHOP_DROPSHIP,
        ShopType.CHANNEL_SHOP_SUPPLIER,
        ShopType.KTT,
        ShopType.AIKUCUN,
        ShopType.AIKUCUN_V2,
        ShopType.XIAOHONGSHU,
    ].includes(shop?.type);
}

export const showIMEI2ShopTypes = [ShopType.PINDUODUO];
export const showDeviceSnShopTypes = [
    ShopType.PINDUODUO,
    ShopType.DOUDIAN,
    ShopType.JD,
    ShopType.KWAI,
    ShopType.TAOBAO,
];
export const showEanCodeShopTypes = [ShopType.DOUDIAN];

export function getIsSupplierManualShop(shop: ShopDTO, globalStore: typeof GlobalStore) {
    return (
        globalStore.companyRoleStore.isSupplier &&
        shop.type === ShopType.MANUAL &&
        SupplierShopTypes.includes(globalStore.shopMapping.get(shop.ownerShopId)?.type)
    );
}

export const notSupportProductManageShopTypes = [
    ShopType.PDD_FDS,
    ShopType.PDD_FULFILLMENT,
    ShopType.ALIBABA_SUPPLIER,
    ...SupplierShopTypes,
];

/** 是否支持按收货人合并的店铺类型 */
export function isConsigneeMergeSupported(shopType: ShopType) {
    return [ShopType.KWAI, ShopType.TAOBAO, ShopType.TAOBAO_DISTRIBUTION].includes(shopType);
}

export const supportCreateProductShopTypes = [ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL];

export function detectShopPlatforms(shops: ShopDTO[]) {
    let tb = false;
    let pdd = false;
    let jd = false;
    let dy = false;
    let ali = false;
    let xhs = false;
    let ks = false;
    let channelShop = false;

    let other = true;

    shops.forEach((shop) => {
        if (
            [
                ShopType.TAOBAO,
                ShopType.TAOBAO_DISTRIBUTION,
                ShopType.ALI_C2M,
                ShopType.TAOBAO_DROP_SHIPPING_SUPPLIER,
            ].includes(shop.type)
        ) {
            tb = true;
            return;
        }

        if ([ShopType.ALIBABA, ShopType.ALIBABA_SUPPLIER].includes(shop.type)) {
            ali = true;
            return;
        }

        if (
            [
                ShopType.PINDUODUO,
                ShopType.PDD_FDS,
                ShopType.PDD_FULFILLMENT,
                ShopType.PDD_DROP_SHIPPING_SUPPLIER,
            ].includes(shop.type)
        ) {
            pdd = true;
            return;
        }

        if (
            [
                ShopType.DOUDIAN,
                ShopType.DOUDIAN_IOP,
                ShopType.DOUDIAN_SUPPLIER,
                ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
            ].includes(shop.type)
        ) {
            dy = true;
            return;
        }

        if ([ShopType.JD, ShopType.JD_PURCHASE, ShopType.JD_DROP_SHIPPING_SUPPLIER].includes(shop.type)) {
            jd = true;
            return;
        }

        if ([ShopType.XIAOHONGSHU].includes(shop.type)) {
            xhs = true;

            return;
        }

        if ([ShopType.KWAI, ShopType.KWAI_DROPSHIP].includes(shop.type)) {
            ks = true;
            return;
        }

        if (
            [ShopType.CHANNEL_SHOP, ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shop.type)
        ) {
            channelShop = true;
            return;
        }
    });

    return {
        hasTb: tb,
        hasPdd: pdd,
        hasJd: jd,
        hasDy: dy,
        hasOther: other,
        hasAli: ali,
        hasXhs: xhs,
        hasKs: ks,
        hasChannelShop: channelShop,
    };
}

export const supportAffiliateMarketerShopTypes = [ShopType.DOUDIAN, ShopType.CHANNEL_SHOP, ShopType.KWAI];

/** 是否为京东厂直店铺 */
export function isJdDropshipShop(shop: ShopDTO) {
    if (!shop) return false;

    return shop.type === ShopType.JD && shop.sellerType === SellerType.JD_DROPSHIP;
}
